import { Box, BoxProps, Image, ImageProps } from '@chakra-ui/react';
import styled from '@emotion/styled';
import React, { useRef, useState } from 'react';
import { BlurhashCanvas } from 'react-blurhash';

const StyledBlurHash = styled(BlurhashCanvas)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;

  canvas {
    width: 100%;
    height: 100%;
    border-radius: inherit;
  }
`;

interface Props extends ImageProps {
  blurhash?: string;
  fallbackImage?: string; // fallbackImage is display when src image is failed to load.
  containerProps?: BoxProps;
}

const ImageWithBlurHash = ({
  blurhash,
  fallbackImage,
  containerProps = {},
  ...imageProps
}: Props) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const imageRef = useRef<HTMLImageElement>(null);

  return (
    <Box
      height={imageProps.height ?? '100%'}
      width={imageProps.width ?? '100%'}
      borderRadius={imageProps.borderRadius}
      position="relative"
      {...containerProps}
    >
      {!isLoaded && (
        <StyledBlurHash hash={blurhash || 'L6Pj0^i_.AyE_3t7t7R**0o#DgR4'} />
      )}
      <Image
        ignoreFallback
        ref={imageRef}
        onLoad={() => setIsLoaded(true)}
        width="100%"
        height="100%"
        objectFit="cover"
        {...imageProps}
        onError={() => {
          if (
            fallbackImage &&
            imageRef.current &&
            imageRef.current.src !== fallbackImage
          ) {
            imageRef.current.src = fallbackImage;
          }
        }}
      />
    </Box>
  );
};

export default ImageWithBlurHash;
